import http from './http';

// 查询可兑换的商品
export const queryExchangeGoods = (params: { exchangeCode: string }) => {
  return http({
    url: '/exchange/code/goods',
    params,
  });
};

// 兑换
export const exchangeGoods = (data: { exchangeCode: string; wyuid: string }) => {
  return http({
    method: 'POST',
    url: '/exchange/execute',
    data,
  });
};
